{
  "greeting": "Hey, I'm Nova. What's your goal? Let's find the right hires and move fast.",
  "composer.placeholder": "Tell me what you want to accomplish…",
  "send": "Send",
  "hero.title": "Build your AI team",
  "hero.subtitle": "Describe your goal — Nova handles the rest.",
  "chip.marketing": "Marketing team",
  "chip.dev": "Dev team",
  "chip.sales": "Sales team"
}
